import { request } from '../http';

const pointService = {
    getByDay: (dataChegada) => {
        return request.post('/pointControl/filter', { dataChegada });
    },
    getById: (id) => {
        return request.post('/pointControl/filter', { id });
    },
    getReport: (body) => {
        return request.post('/pointControl/report', body);
    },
    post: (body) => {
        return request.post('/pointControl', body);
    },
    patch: (body, id) => {
        return request.patch(`/pointControl/${id}`, body);
    },
    delete: (id) => {
        return request.delete(`/pointControl/${id}`);
    }
};

export {
    pointService
};
